import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Images from "../../assests/Images";
import { useMutation, useQuery } from "react-query";
// import { purchaseData } from "../globalApi/Api";
import axios from "axios";
import PopupModel from "../popupmodel/PopupModel";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import * as XLSX from "xlsx";
import DatePicker from "react-datepicker";
const PurchaseReport = () => {

    const {
        control,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();

    const purchaseData = async () => {
        const response = await axios.get(`${process.env.REACT_APP_HOST}/invoicesnew`);
        return response.data; // ✅ Important
    };

    const [searchTerm, setSearchTerm] = useState("");


    const [selectedRows, setSelectedRows] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const navigate = useNavigate();


    const fromDate = watch('fromDate');
    const toDate = watch('toDate');


    const [popupType, setPopupType] = useState({
        type: "",
        data: "",
    });

    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setPopupType({
            type: "",
            data: "",
        });
    };


    // GET API START
    const { data, isLoading, isError, refetch } = useQuery(
        "purchase",
        purchaseData,
        {
            refetchOnWindowFocus: false,
        }
    );

    console.log("data", data)

    let details = data && data || [];
    // GET API END


    // Filter By search
    const filteredDetails =
        details &&
        details?.filter((item) => {
            // const nameMatch = item?.productName
            //   ?.toLowerCase()
            //   .includes(searchTerm.toLowerCase());
            const idMatch = String(item?.id).includes(searchTerm); // assuming `id` is a number or string

            // Format salesDate and from/toDate as YYYY-MM-DD
            const itemDateStr = item?.purchaseDate
                ? moment(item?.purchaseDate).format('YYYY-MM-DD')
                : null;

            const fromDateStr = fromDate ? moment(fromDate).format('YYYY-MM-DD') : null;
            const toDateStr = toDate ? moment(toDate).format('YYYY-MM-DD') : null;

            const fromDateMatch =
                !fromDateStr || itemDateStr >= fromDateStr;

            const toDateMatch =
                !toDateStr || itemDateStr <= toDateStr;

            const dateMatch = fromDateMatch && toDateMatch;


            return idMatch && dateMatch;
        });


    let totalLength = details && details?.length;


    // Handle checkbox change
    const handleCheckboxChange = (id) => {
        setSelectedRows((prevSelectedRows) => {
            const isSelected = prevSelectedRows?.includes(id);
            if (isSelected) {
                return prevSelectedRows?.filter((rowId) => rowId !== id);
            } else {
                return [...prevSelectedRows, id];
            }
        });
    };

    // Download Excel
    const downloadExcel = () => {
        // Define headers
        const headers = [
            "PURCHASE ID",
            "PRODUCT NAME",
            "UNIT PRICE",
            "QUANTITY",
            "QUANTITY TYPE",
            "PRODUCT FOR",
        ];

        // Map data to match the headers order
        const formattedData =
            filteredDetails &&
            filteredDetails?.map((item, index) => ({
                "PURCHASE ID": index + 1,
                "PRODUCT NAME": item?.vendorDetails?.map((d) => d?.product).join(",") || "",
                "UNIT PRICE": item?.vendorDetails?.map((d) => d?.unitPrice).join(",") || "",
                QUANTITY: item?.vendorDetails?.map((d) => d?.quantity).join(",") || "",
                "QUANTITY TYPE": item?.vendorDetails?.map((d) => d?.quantityType).join(",") || "",
                "PRODUCT FOR": item?.vendorDetails?.map((d) => d?.productFor).join(",") || "",
            }));

        // Create a new workbook and a worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate Excel file and trigger download
        XLSX.writeFile(wb, "View Purchase.xlsx");
    };


    return (
        <>

            <div className="view_form_block">
                <div className="view_form_sub_block">
                    {/* DASHBOARD */}
                    <div className="row my-3 d-flex justify-content-center">
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 dashborad-card-block --first-block">
                            <span className="dashboard-heading">Purchase</span>
                            <span className="dashboard-value">{totalLength || 0}</span>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 dashborad-card-block">
                            <span className="dashboard-heading">Return</span>
                            <span className="dashboard-value">0</span>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 dashborad-card-block">
                            <span className="dashboard-heading">Debit</span>
                            <span className="dashboard-value">0</span>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 dashborad-card-block --last-block">
                            <span className="dashboard-heading">Total Purchase</span>
                            <span className="dashboard-value">0</span>
                        </div>
                    </div>
                    {/* Filter and Search */}
                    <div className="row px-1 d-flex justify-content-between">
                        <div className="col-12 col-md-3">
                            <input
                                type="search"
                                className="view_table_search"
                                placeholder="Search by Purchase ID"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-12 col-md-9 d-flex align-items-center justify-content-end gap-2">
                            <Controller
                                control={control}
                                name="fromDate"
                                render={({ field }) => (
                                    <DatePicker
                                        {...field}
                                        selected={field.value}
                                        onChange={field.onChange}
                                        dateFormat="yyyy-MM-dd"
                                        placeholderText="Select From Date"
                                        maxDate={new Date()}
                                        className="filter_date_picker"
                                    />
                                )}
                            />
                            <Controller
                                control={control}
                                name="toDate"
                                render={({ field }) => (
                                    <DatePicker
                                        {...field}
                                        selected={field.value}
                                        onChange={field.onChange}
                                        dateFormat="yyyy-MM-dd"
                                        placeholderText="Select To Date"
                                        minDate={fromDate}
                                        maxDate={new Date()}
                                        className="filter_date_picker"

                                    />
                                )}
                            />

                            {/* Download Button */}
                            <div className="download_btn_block_purchase d-flex align-items-center" onClick={downloadExcel}
                                style={{ width: "50%" }}
                            >
                                <div className="download_image_block">
                                    <img
                                        src={Images?.downloadIcon}
                                        className="image_icon"
                                        alt="no-image"
                                    />
                                </div>
                                <button className="download_btn">DOWNLOAD</button>
                            </div>



                        </div>
                    </div>
                    <div className="row px-3 my-3">
                        <div className="col-lg-12 view_table_section">
                            <div className="table-responsive view_table_block">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            {/* <th className="view-table-heading">SELECT</th> */}
                                            <th className="view-table-heading">PURCHASE ID</th>
                                            <th className="view-table-heading">PRODUCT NAME</th>
                                            <th className="view-table-heading">PURCHASE DATE</th>
                                            <th className="view-table-heading">PRODUCT FOR</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            isLoading ? (
                                                <>
                                                    <h5 className="my-3">L O A D I N G . . .</h5>
                                                </>) : (
                                                filteredDetails?.length > 0 ? (
                                                    <>
                                                        {filteredDetails?.map((data, i) => {
                                                            return (
                                                                <>
                                                                    <tr key={i} >

                                                                        <td className="view-table-data">
                                                                            {data?.id || "-"}
                                                                        </td>
                                                                        <td className="view-table-data">
                                                                            {data?.vendorDetails?.length > 0
                                                                                ? data?.vendorDetails?.map((d) => d?.product).join(", ")
                                                                                : "-"}
                                                                        </td>
                                                                        <td className="view-table-data">
                                                                            {data?.purchaseDate ? moment(data?.purchaseDate).format("DD-MM-YYYY") : ""}
                                                                        </td>
                                                                        <td className="view-table-data">
                                                                            {data?.vendorDetails?.length > 0
                                                                                ? data?.vendorDetails?.map((d) => d?.productFor).join(", ")
                                                                                : "-"}
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            );
                                                        })}
                                                    </>
                                                ) : (
                                                    <>
                                                        <h6>No Record Founds</h6>
                                                    </>
                                                )
                                            )
                                        }

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PurchaseReport